/* eslint-disable no-useless-call */
import AppService from '@/assets/service/App'
import manageService from '@/assets/service/manage'
import { getCookie, setCookie } from '@/assets/utils/CommonUtil'
import { env, pcode } from '@/assets/js/config'
// import {typeOf} from '@zjy/zjy-ui/lib/utils/dom'
// import _ from 'lodash'

export default {
  methods: {
    /*
      1. 埋点 公共方法
      @params: 参数
         fnGroup: 功能分组 (对应excel 模块 列) String
         fnName:  功能名称 (对应excel 名称 列) String
         fnCode:  功能编码 String || Number
         extJson: 扩展字段，Object (对应excel 属性 列 需要传递的值)，role 角色字段会统一追加到此参数， 无需每次调用传递
         config:  可配置，Object (如: pcode: 其它产品的 产品码; noGA: true 代表只做IO埋点， 无需GA 埋点)
      @return: null
     */
    async sendLog (fnGroup, fnName, fnCode, extJson = {}, config = {}) {
      if (config.noGA === true) {} else {
        // this.$ga.event(fnName, fnGroup, this.role || '', fnCode)
        // window.ga('send', 'event', fnName, fnGroup, this.role || '', fnCode)
      }
      const params = {
        fnGroup,
        fnName,
        fnCode,
        debug: !(env === 'product'), // 只统计正式环境数据 ?
        pcode // 产品码 造价云: 正式 -101001 非正式 84420
      }
      if (config.pcode) { params.pcode = config.pcode } // 若 配置参数config里指定了产品码 则使用该产品码
      if (this.role) {
        params.role = this.role
        if (!extJson.role) {
          extJson.role = this.role
        }
        extJson.roleName = this.roleName
      }
      try {
        if (this.role !== 5) {
          // 获取分支地区
          const entArea = getCookie('entArea')
          const entGroup = getCookie('entGroup')
          const entId = getCookie('entId')
          if (entArea === null || entGroup === null || entId === null) {
            await manageService.getBranchAndArea().then(res => {
              if (res.code === 200 && res.data) {
                const { entArea = '', entGroup = '', entId = '' } = res.data || {}
                setCookie('entArea', entArea)
                setCookie('entGroup', entGroup)
                setCookie('entId', entId)
                Object.assign(extJson, { entArea, entGroup, entId })
              }
            })
          } else {
            Object.assign(extJson, { entArea, entGroup, entId })
          }
        }
        params.extJson = JSON.stringify(extJson)
      } catch (e) { console.log(e) }
      let userInfo = getCookie('ZJYUSERINFO')
      if (userInfo){
        try {
          userInfo = JSON.parse(userInfo)
          params.gldUserId = userInfo.gldUserId
        } catch (e) { console.log(e) }
      }
      AppService.senLog(params).then(res => {}).catch((e) => { console.log(e) })
    },
    /*
      1.1 埋点 公共方法
      @params: 参数
         fnCode:  功能编码 String || Number
         extJson: 扩展字段，Object (对应excel 属性 列 需要传递的值)，role 角色字段会统一追加到此参数， 无需每次调用传递
     */
    sentLog (fnCode, extJson = {}) {
      const dicFile = require('@/assets/js/logExcel/all.json')
      if (dicFile && fnCode && dicFile[fnCode]) {
        const {fnGroup, fnName} = dicFile[fnCode]
        this.sendLog(fnGroup, fnName, fnCode, extJson)
      }
    }
  }
}
